export default __webpack_public_path__ + "static/media/24t.0f50e953.jpg";